import React, {Component, FunctionComponent, useEffect} from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  RouteProps
} from "react-router-dom";
import Home from './pages/Home/Home'
import Booths from './pages/Booths/Booths'
import Lobby from './pages/Lobby/Lobby'
import Booth from './pages/Booth/Booth'
import Login from './pages/Login/Login'
// import ProductPresentation from './pages/ProductPresentation/ProductPresentation'
import GreenForums from './pages/GreenForums/GreenForums'
import LobbyIntroVideo from './pages/LobbyIntroVideo/LobbyIntroVideo'
import { useSelector } from 'react-redux';
import WebinarMeet from './pages/WebinarMeet/WebinarMeet'
import VideoCall from './pages/VideoCall/VideoCall'
import LinkedInPopUp from "./pages/Login/LinkedInPopUp";
import {RouteComponentProps} from "react-router";
import VideoCallBusy from './pages/VideoCallBusy/VideoCallBusy'

interface IPrivateRoute extends RouteProps {
  component: React.ComponentType<any>;
  preventAccess?: boolean;
  requireAuth?: boolean;
}

const PrivateRoute = ({ component: Component, preventAccess = false, requireAuth = false, ...rest }: IPrivateRoute) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if(preventAccess) {
    return <Redirect to="/introvideo" />
  }

  if(requireAuth && !isAuthenticated) {
    return <Redirect to="/login" />
  }
  
  return <Route {...rest}>
    <Component />
  </Route>
}

const Routes = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Router>
      <Switch>
        <PrivateRoute path="/videocallbusy" requireAuth={true} component={VideoCallBusy} />
        <PrivateRoute path="/webinar/:room" requireAuth={true} component={WebinarMeet} />
        <PrivateRoute path="/meet/:url" requireAuth={true} component={VideoCall} />
        <PrivateRoute path="/introvideo" requireAuth={true} component={LobbyIntroVideo} />
        <PrivateRoute path="/lobby" requireAuth={true} component={Lobby} />
        <PrivateRoute path="/booths" requireAuth={true} component={Booths} />
        <PrivateRoute path="/booth/:id" requireAuth={true} component={Booth} />
        {/*<PrivateRoute path="/productpresentation" requireAuth={true} component={ProductPresentation} />*/}
        <PrivateRoute path="/greenforums" requireAuth={true} component={GreenForums} />
        <PrivateRoute path="/login" preventAccess={isAuthenticated} component={Login} />
        <PrivateRoute path="/linkedin" preventAccess={isAuthenticated} component={LinkedInPopUp} />
        <PrivateRoute path="/register" component={Home} />
        <PrivateRoute path="/" component={Home} />
      </Switch>
    </Router>
  );
}

export default Routes;
